import template from 'string-template'

export default function({
  tooltipTemplate,
  data
}) {
  return template(tooltipTemplate, data)
}



/** WEBPACK FOOTER **
 ** ./src/utils/render_tooltip.js
 **/